// extracted by mini-css-extract-plugin
module.exports = {"iconMenu":"IconMenu_iconMenu__1_QOr"};